import { IIconProps } from './constants';

export const InfoIcon = ({ width = 24, height = 24, ...rest }: IIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M12.1494 1.83334C6.62656 1.83334 2.14941 6.31049 2.14941 11.8333C2.14941 17.3562 6.62657 21.8333 12.1494 21.8333C17.6723 21.8333 22.1494 17.3562 22.1494 11.8333C22.1494 6.31049 17.6723 1.83334 12.1494 1.83334Z"
      stroke="currentcolor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.1494 15.8333L12.1494 11.8333"
      stroke="currentcolor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.1494 7.83334L12.1394 7.83334"
      stroke="#061D33"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
